import * as SurveyPDF from 'survey-pdf';

export class CustomPdfBrick extends SurveyPDF.PdfBrick {
    
    async renderInteractive() {
        
      const doc = this.controller.doc;
      
      let newVal="";
      var options = {
        fontSize: 10,
        margins: {
            left: 10,
            right: 10,
            top: 10,
            bot: 10
        }        
    };
      if (this.question.value !== undefined) {
        this.question.value.reverse();
        for (let k = 0; k < this.question.value.length; k++) {
          newVal = newVal +'- ' + this.question.value[k].FileName;
          if (k < this.question.value.length - 1) {
            newVal = newVal + "\n";
          }
        }             
      }
      else{
        newVal="No files are attached."
      }      
      doc.text(newVal, this.xLeft , this.yTop + 7, options, "F");      
    }
  }
  export class FlatCustomQuestion extends SurveyPDF.FlatQuestion {
    async generateFlatsContent(point) {
       
      const rect = { ...point };
      rect.yBot = point.yTop + 20;
      rect.xRight = point.xLeft + 100;
      return [new CustomPdfBrick(this.question, this.controller, rect)];
    }
  }